import { render } from "./IjinKenriCounter.vue?vue&type=template&id=c72ad19a"
import script from "./IjinKenriCounter.vue?vue&type=script&lang=js"
export * from "./IjinKenriCounter.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__